import { render, staticRenderFns } from "./TokenAddCustom.vue?vue&type=template&id=ac066b02&scoped=true&"
import script from "./TokenAddCustom.vue?vue&type=script&lang=js&"
export * from "./TokenAddCustom.vue?vue&type=script&lang=js&"
import style0 from "./TokenAddCustom.vue?vue&type=style&index=0&id=ac066b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac066b02",
  null
  
)

export default component.exports